<template>
  <div
    :class="['common-page', `page-${routeKey}`]"
    :style="`background-image: url(${pageData.title_bg})`"
  >
    <section class="title-container">
      <h1 v-html="`${pageData.title}<br>解决方案`"></h1>

      <img
        class="dataCenter-pic"
        v-if="routeKey == 'dataCenter'"
        :src="require('../assets/images/dataCenter_pic.png')"
      />

      <div class="sub-describe">
        <template v-if="pageData.qsTitle">
          <div class="qs-title">{{ pageData.qsTitle }}</div>
          <div class="qs">
            <span v-for="(item, index) in pageData.qs" :key="index">{{
              item
            }}</span>
          </div>
        </template>
        <div
          v-if="pageData.describe"
          v-html="pageData.describe"
          class="sub-desc"
        ></div>
      </div>

      <img v-if="pageData.perview_pic" :src="pageData.perview_pic" alt="" />
    </section>
    <van-tabs
      v-model="activeTab"
      v-if="pageData.typeVideoList && pageData.typeVideoList.length"
      class="type-tabs"
      :line-height="0"
      :sticky="true"
      :background="pageData.bgColor"
      :ellipsis="false"
      @change="typeChange"
    >
      <van-tab
        :title="item.type"
        v-for="(item, typeIndex) in pageData.typeVideoList"
        :key="item.value"
        :name="item.value"
      >
        <section class="video-list type-video-list">
          <div
            class="video-item"
            v-for="(item, index) in item.videoList"
            :key="index"
          >
            <img :src="item.poster" />
            <div class="video-container">
              <img
                class="play-icon"
                :src="posterImg"
                @click="videDetails(index, typeIndex)"
              />
              <h3 v-html="item.title"></h3>
            </div>
          </div>
        </section>
      </van-tab>
    </van-tabs>
    <!-- 当前页面播放的视频 -->
    <section class="preview-video" v-if="pageData.preview_video">
      <video-play :videoList="[pageData.preview_video]"></video-play>
    </section>

    <!-- 详情-跳转 -->
    <section
      :class="[
        'video-list',
        `video-list-${pageData.videoList.length % 2 ? 'odd' : 'even'}`,
      ]"
      v-if="pageData.videoList && pageData.videoList.length"
    >
      <div
        class="video-item"
        v-for="(item, index) in pageData.videoList"
        :key="index"
      >
        <img :src="item.poster" />
        <div class="video-container">
          <img class="play-icon" :src="posterImg" @click="videDetails(index)" />
          <h3 v-html="item.title"></h3>
          <p>{{ item.describe }}</p>
        </div>
      </div>
    </section>

    <!-- 尾图 -->
    <div
      v-if="pageData.tail_images && pageData.tail_images.length"
      class="tail-images"
    >
      <img
        :src="item"
        v-for="(item, index) in pageData.tail_images"
        :key="index"
      />
    </div>

    <!-- 小鸟探店星标列表 -->
    <section class="star-list" v-if="routeKey == 'storeVisit'">
      <img class="" :src="require('../assets/images/storeVisit_pic.png')" />
      <div v-for="(item, index) in pageData.starList" :key="index">
        {{ item }}
      </div>
    </section>

    <!-- 线上引流 -->
    <section class="onlineDrainage-details" v-if="routeKey == 'onlineDrainage'">
      <img src="../assets/images/onlineDrainage_pic.png" />
      <div class="star-list">
        <div
          v-for="(item, index) in pageData.starList"
          :key="index"
          v-html="item"
        ></div>
      </div>
    </section>

    <!-- 悬浮按钮 -->
    <float-button :list="urlList"></float-button>
  </div>
</template>

<script>
import commonInfo from "../assets/js/commonInfo.js";
import VideoPlay from "./../components/videoPlay";
import posterImg from "./../assets/images/wdz_pc_play_icon_20220118.png";
import FloatButton from "../components/float-button.vue";
import { Tab, Tabs } from "vant";
import storageHelper from "../utils/storage";

export default {
  name: "common-page",
  components: { VideoPlay, FloatButton, [Tabs.name]: Tabs, [Tab.name]: Tab },
  computed: {
    routeKey() {
      return this.$route.query.key;
    },
    pageData() {
      return commonInfo[this.$route.query.key];
    },
    urlList() {
      let arr = [];
      Object.keys(commonInfo).forEach((item) =>
        arr.push({
          title: commonInfo[item].title,
          key: item,
          bgColor: commonInfo[item].bgColor,
        })
      );
      return arr;
    },
  },

  data() {
    return {
      posterImg: posterImg,
      activeTab: "",
    };
  },
  mounted() {
    if (this.pageData.typeVideoList && this.pageData.typeVideoList.length) {
      console.log("🚀 ~ mounted ~ this.AIType:", this.AIType);
      let AIType = storageHelper.getTempData("AIType");
      if (AIType) {
        this.activeTab = AIType;
      } else {
        this.activeTab = this.pageData.typeVideoList[0].value;
        storageHelper.setTempData("AIType", this.activeTab);
      }
    } else {
      storageHelper.removeTempData("AIType");
    }
  },

  methods: {
    /**
     * 查看video详情
     */
    videDetails(index, typeIndex = null) {
      let query = {
        key: this.routeKey,
        index,
      };
      if (typeof typeIndex === "number") {
        query.typeIndex = typeIndex;
      }
      this.$router.push({
        path: "/detect-details",
        query: query,
      });
    },
    typeChange(active) {
      storageHelper.setTempData("AIType", active);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.common-page {
  $font_color: #fff;
  padding: 32px 16px 56px;
  background-size: contain;
  background-repeat: no-repeat;
  section.title-container {
    padding: 16px;
    text-align: left;
    h1 {
      color: $font_color;
      font-size: 40px;
      font-weight: 600;
      line-height: 52px;
      letter-spacing: 1px;
      text-align: left;
    }
    .sub-describe {
      margin-top: 20px;
      // margin-bottom: 15px;
      .qs-title {
        font-size: 16px;
        font-weight: 400;
        color: #ffffffb3;
      }
      .qs {
        display: flex;
        flex-wrap: wrap;
        span {
          font-size: 11px;
          font-weight: 600;
          color: #ffffff;
          padding: 3px 9px;
          border-radius: 4px;
          background: #7e0707;
          margin-top: 8px;
          margin-right: 8px;
        }
      }
      .sub-desc {
        font-weight: 400;
        font-size: 14px;
        color: #ffffffb3;
        line-height: 24px;
        text-align: left;
      }
    }
  }
  section.preview-video {
    margin-top: 8px;
  }
  section.video-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .video-item {
      width: calc(50% - 5.5px);
      overflow: hidden;
      border-radius: 12px;
      margin-bottom: 11px;
      position: relative;
      .video-container {
        width: 100%;
        height: 100%;
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        background-image: linear-gradient(180deg, #000000b3 0%, #00000000 100%);
        position: absolute;
        top: 0;
        left: 0;
        padding: 16px;
        img.play-icon {
          width: 54px;
          height: 54px;
          padding: 12px;
          border-radius: 50%;
          background-color: #0000004d;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        h3 {
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
          line-height: 23px;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
        }
      }
    }
    &-odd {
      .video-item:last-child {
        width: 100%;
      }
    }
  }
  .tail-images {
    margin-top: 16px;
  }
  .type-video-list {
    margin-top: 22px;
  }
  .type-tabs {
    ::v-deep {
      .van-tab {
        padding: 0 6px 0 0;
        .van-tab__text {
          padding: 8px 6px;
          font-size: 12px;
          color: #e6e6e6;
          line-height: 18px;
          background: #ffffff29;
          border-radius: 6px;
          border: 0.5px solid transparent;
          box-sizing: border-box;
        }
        &:last-child {
          padding: 0;
        }
      }
      .van-tab--active {
        .van-tab__text {
          background: #0536cc;
          border: 0.5px solid #0093ff;
          color: #ffffff;
          font-weight: 600;
        }
      }
    }
  }
}
// 星标列表
.star-list {
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  div {
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    position: relative;
    display: flex;
    &::before {
      content: "";
      width: 14px;
      height: 14px;
      display: inline-block;
      background-size: cover;
      margin-right: 8px;
      left: 0;
    }
  }
}

// 数据中心
.page-dataCenter {
  .dataCenter-pic {
    padding: 10px 13px;
    border-radius: 16px;
    background: #ffffff1f;
    margin-top: 16px;
  }
}
// 小鸟探店
.page-storeVisit {
  padding: 0;
  $font_color: #000 !important;
  h1,
  div {
    color: $font_color;
  }
  > section:not(.star-list) {
    padding: 16px;
    &:first-of-type {
      padding: 32px;
    }
    &:nth-of-type(2) {
      padding-top: 8px;
    }
  }
  // 星标列表
  .star-list {
    padding: 0 16px 160px;
    background-image: url("../assets/images/storeVisit_bg.png");
    div {
      align-items: center;
      &::before {
        background-image: url("../assets/images/storeVisit_star.png");
      }
    }
  }
}
// 线上引流
.page-onlineDrainage {
  h1 {
    color: #ff5300 !important;
  }
  .sub-describe {
    margin-top: 126px !important;
  }
  section.onlineDrainage-details {
    > img {
      width: 100%;
    }
    span {
      color: white;
    }
    .star-list {
      margin-top: 30px;
      div {
        flex-direction: column;
        align-items: flex-start;
        padding-left: 32px;
        /deep/ span {
          color: white;
          font-size: 14px;
          line-height: 24px;
          display: block;
          &:first-child {
            font-weight: 600;
          }
          &:last-child {
            font-weight: 400;
          }
        }
        &::before {
          width: 24px;
          height: 24px;
          background-size: 16px 16px;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url("../assets/images/onlineDrainage_star.png");
          position: absolute;
          top: 0;
        }
      }
    }
  }
  // 星标列表
}

@media screen and (min-width: $maxWidth) {
  .common-page {
    padding: 32px 16px;
    section.title-container {
      padding: 16px;
      h1 {
        font-size: 40px;
        line-height: 52px;
        letter-spacing: 1px;
      }
      .sub-describe {
        margin-top: 20px;
        .qs-title {
          font-size: 16px;
        }
        .qs {
          span {
            font-size: 11px;
            padding: 3px 9px;
            border-radius: 4px;
            margin-top: 8px;
            margin-right: 8px;
          }
        }
        .sub-desc {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
    section.preview-video {
      margin-top: 8px;
    }
    section.video-list {
      .video-item {
        width: calc(50% - 5.5px);
        border-radius: 12px;
        margin-bottom: 11px;
        .video-container {
          padding: 16px;
          img.play-icon {
            width: 54px;
            height: 54px;
            padding: 12px;
            border-radius: 50%;
          }
          h3 {
            font-size: 20px;
            line-height: 23px;
          }
          p {
            font-size: 15px;
            line-height: 18px;
          }
        }
      }
    }
  }
  // 星标列表
  .star-list {
    div {
      font-size: 14px;
      line-height: 28px;
      &::before {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
    }
  }

  // 数据中心
  .page-dataCenter {
    .dataCenter-pic {
      padding: 10px 13px;
      border-radius: 16px;
      margin-top: 16px;
    }
  }
  // 小鸟探店
  .page-storeVisit {
    > section:not(.star-list) {
      padding: 16px;
      &:first-of-type {
        padding: 32px;
      }
      &:nth-of-type(2) {
        padding-top: 8px;
      }
    }
    // 星标列表
    .star-list {
      padding: 0 16px 160px;
    }
  }
  // 线上引流
  .page-onlineDrainage {
    .sub-describe {
      margin-top: 126px !important;
    }
    section.onlineDrainage-details {
      .star-list {
        margin-top: 30px;
        div {
          padding-left: 32px;
          /deep/ span {
            font-size: 15px;
            line-height: 24px;
          }
          &::before {
            width: 24px;
            height: 24px;
            background-size: 16px 16px;
          }
        }
      }
    }
    // 星标列表
  }
}
</style>
